





























import Vue from 'vue'
import AdvancedSearch from '@/UI/Shared/AdvancedSearch.vue'
import ProvinceSelector from '@/UI/Shared/ProvinceSelector.vue'
import SimpleInput from '@/UI/Shared/SimpleInput.vue'

export default Vue.extend({
  name: 'WonProceduresListSearch',
  components: { AdvancedSearch, SimpleInput, ProvinceSelector },
  data () {
    return {
      query: '',
      numExpediente: '',
      province: '',
      lote: ''
    }
  },
  methods: {
    onSearchCleaned () {
      this.query = ''
      this.numExpediente = ''
      this.province = ''
      this.lote = ''
      this.onSearchRequested()
    },
    onSearchRequested () {
      this.$emit('filters-updated', {
        code: this.query,
        numExpediente: this.numExpediente,
        province: this.province,
        lote: this.lote
      })
    },
    onProvinceUpdated (input: string | number) {
      this.province = input.toString()
    }
  }
})
